import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import JSONSchemaForm from "@rjsf/core";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import customFormats from "@beeldit/core/custom-validations/custom-validation";
import useProcessSchema from "@beeldit/core/hooks/useProcessSchema";
import widgets from "@beeldit/core/widgets/widgets";
import MultidimensionalCustomFormTemplate from "@beeldit/core/templates/MultidimensionalCustomFormTemplate";

interface Prop {
  formConfig: {
    formRef: any;
    onSubmit: any;
    context: any;
    action: string;
    className?: string;
    formDefaultValues?: any;
  };
}

interface Context {
  element: any;
  setElement: (element: any) => any;
  backendFormErrors: any;
}

function RequestInvoiceSuperOrderForm(props: Prop) {
  const { formRef, onSubmit, context, action, className, formDefaultValues } =
    props.formConfig;
  const { element, setElement, backendFormErrors } =
    useContext<Context>(context);

  const { t } = useTranslation();

  console.log('Element', element);
  const [finalSchema, setFinalSchema] = useState<RJSFSchema>({});
  const translations = {
    fiscal_name: t("fiscal_name"),
    fiscal_first_surname: t("fiscal_first_surname"),
    fiscal_address: t("fiscal_address"),
    fiscal_zip: t("fiscal_zip"),
    fiscal_city: t("fiscal_city"),
    fiscal_province: t("fiscal_province"),
    fiscal_country_code: t("fiscal_country_code"),
  };

  let schema: any = {
    type: "object",
    properties: {
      billing_address: {
        type: "object",
        title: "",
        properties: {
          fiscal_name: {
            type: ["string"],
            title: translations.fiscal_name,
          },
          fiscal_first_surname: {
            type: ["string"],
            title: translations.fiscal_first_surname,
          },
          fiscal_address: {
            type: ["string"],
            title: translations.fiscal_address,
          },
          fiscal_zip: {
            type: ["string"],
            title: translations.fiscal_zip,
          },
          fiscal_city: {
            type: ["string"],
            title: translations.fiscal_city,
          },
          fiscal_province: {
            type: ["string"],
            title: translations.fiscal_province,
          },
          fiscal_country_code: {
            type: ["string"],
            title: translations.fiscal_country_code,
          }
        }
      }

    },
  };

  const uiSchema = {
    "ui:classNames": className,
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    colsSchema: [
      {
        cols: "col-12",
        elements: [
          [
            {
              name: "billing_address",
              cols: "col-6",
            }
          ]
        ]
      }
    ]
  };
  const customWidgets = {
    ...widgets,
  };
  const handleChange = (type: any) => {
    /** Este método de momento es necesario aunque en realidad no tenga sentido, pero se debe a un bug de la libreria */
    // Actualizar el estado solo si no hay errores de validación
    setElement(type.formData);
    return console.log.bind(console, type);
  };
  const log = (type: any) => {
    return console.log.bind(console, type);
  };

  const formats = customFormats;
  const validator = customizeValidator({ customFormats: formats });

  const processSchemaFunction = useProcessSchema();

  useEffect(() => {
    setFinalSchema(processSchemaFunction(schema, element));
  }, [element]);

  const formTemplate = MultidimensionalCustomFormTemplate;

  return (
    <JSONSchemaForm
      noHtml5Validate
      showErrorList={false}
      ref={formRef}
      schema={finalSchema}
      uiSchema={uiSchema}
      widgets={customWidgets}
      formData={element}
      validator={validator}
      onChange={handleChange}
      onSubmit={onSubmit}
      onError={log("errors")}
      extraErrors={backendFormErrors}
      templates={{
        ObjectFieldTemplate: formTemplate,
      }}
    />
  );
}

export default RequestInvoiceSuperOrderForm;
